/* eslint-disable import/no-anonymous-default-export */
import { Form, Input, Modal, Select, Spin, Table, message } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import { useEffect, useRef, useState } from "react";
import useConveniosPagoAPI, { ConvenioPago } from "../useConveniosPagoAPI";
import DataTable from "../../common/components/DataTable";
import MainLayout from "../../common/components/MainLayout";
import moment from "moment-business-days";
import DataFilter from "../../common/components/DataFilter";
import styled from "styled-components";
import ActaPreview, { ActaPreviewRef } from "../../infracciones/components/ActaPreview";
import InfraccionesInfractorList from "../components/InfraccionesInfractorList";
import InfraccionesInfractorTable from "../components/InfraccionesInfractorTable";
import { Infraccion } from "../../infracciones/hooks/useInfraccionesAPI";
import { Query } from "../../common/hooks/useApi";
import TablaCuotas from "../components/EstadoCuotas";

const FullscreenSpin = styled.div`
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
display: flex;
align-items: center;
justify-content: center;
z-index: 100000;
background: rgba(255,255,255,0.5);`

const now = moment().endOf('day')

export default () => {
    const api = useConveniosPagoAPI();
    const createPage = "/convenios-pago/guardar"
    const editPage = "/convenios-pago/guardar/{Id}"

    const [cuitCuilFilterForm] = Form.useForm()
    const [estadoPagoFilterForm] = Form.useForm()
    const [estadoVencimientoFilterForm] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [selectedConvenio, setSelectedConvenio] = useState<number>()
    const [convenioPdfUrl, setConvenioPdfUrl] = useState<string>()
    const [data, setData] = useState<Infraccion[]>([]);
    const [cuotas, setCuotas] = useState<any[]>([]);
    const [verTablacuotas, setVerTablaCuotas] = useState(false);

    const generateFilters = (filters: Record<string, FilterValue | null>) => {
        return [
            filters?.Infractor != null ? `contains(Infractor/CuilTitular,'${filters!.Infractor![0]}')` : "",
            filters?.EstadoPago != null ? `EstadoPago eq '${filters!.EstadoPago![0]}'` : "",
            filters?.Estado != null ? `Vencimiento_Cuota1 ${filters!.Estado![0] == 1 ? 'gt' : 'le'} ${now.format("YYYY-MM-DD")}` : "",
        ];
    }

    const showPdf = async (id: number) => {
        setLoading(true)
        try {
            const response = await api.pdfDownload(id)
            if (response.error) throw new Error()
            setConvenioPdfUrl(response.data!)
            /*
            const link = document.createElement('a');
            link.href = response.data!;
            link.setAttribute('download', `convenio-${id}.pdf`);
            document.body.appendChild(link);
            link.click();*/
        }
        catch (e) {
            console.error(e)
            message.error("Error al descargar el .pdf")
        }
        setLoading(false)
    }

    useEffect(() => {
        api.listInfraccionesConvenio({}, selectedConvenio ?? 0).then(result => {
            if (!result.error && result.data) {
                setData(result?.data.value ?? []);
            }
        });
    }, [selectedConvenio])

    async function verEstadoCuotas(convenioId: number): Promise<any> {
        var response = await api.verEstadoCuotas(convenioId);
        console.log(response.data);
        setCuotas(response.data ?? []);
        setVerTablaCuotas(true);
    }

    async function regenerarCuotasVencidas(Id: number): Promise<any> {
        Modal.confirm({
            title: 'Confirmar regeneración',
            content: '¿Estás seguro de que deseas regenerar las cuotas vencidas? Esta acción no se puede deshacer.',
            okText: 'Sí, regenerar',
            cancelText: 'Cancelar',
            onOk: async () => {
                try {
                    var fueRegenerada = await api.regenerarCuotasVencidas(Id);

                    if (fueRegenerada) {
                        message.success("Cuotas vencidas regeneradas correctamente");
                        //verEstadoCuotas(Id);
                        showPdf(Id);
                    }
                    else {
                        message.error("Error al regenerar cuotas vencidas");
                    }
                } catch (error) {
                    message.error("Ocurrió un error al regenerar las cuotas");
                }
            },
            onCancel: () => {
                message.info("Operación cancelada");
            }
        });
    }

    return (
        <MainLayout >
            {loading && <FullscreenSpin>
                <Spin size="large" />
            </FullscreenSpin>}

            <Modal
                width={"90%"}
                style={{ maxWidth: "1024px" }}
                bodyStyle={{ height: "80vh", overflow: "auto" }}
                onCancel={() => setConvenioPdfUrl(undefined)}
                visible={convenioPdfUrl !== undefined} footer={null} >
                {convenioPdfUrl && <iframe style={{ width: "100%", height: "100%" }} src={convenioPdfUrl} />}
            </Modal>

            <Modal
                width={"90%"}
                style={{ maxWidth: "1024px" }}
                bodyStyle={{ maxHeight: "500px", overflow: "auto" }}
                visible={selectedConvenio != undefined}
                footer={null}
                onCancel={() => setSelectedConvenio(undefined)}
            >
                {selectedConvenio && <InfraccionesInfractorTable
                    key={selectedConvenio}
                    list={((query) => api.listInfraccionesConvenio(query, selectedConvenio))}
                    title={`Infracciones del convenio ${selectedConvenio}`}
                    sourceData={data}
                />}
            </Modal>

            <Modal
                width={"80%"}
                open={verTablacuotas}
                onCancel={() => setVerTablaCuotas(false)}
            >
                <TablaCuotas data={cuotas} />
            </Modal>



            <DataTable<ConvenioPago, ConvenioPago>
                list={(query) => {
                    const u = JSON.parse(localStorage.getItem("_user") ?? "");
                    if (u.rol.nombre == 'Gestor convenios') {
                        const result = api.list({
                            ...query,
                            ...{
                                $expand: ["Infractor", "Usuario", "ConvenioInfracciones"],
                                $select: ["Vencimiento_Cuota1", "Id", "CreatedAt", "Infractor", "Usuario", "ConvenioInfracciones", "EstadoPago"],
                                $filter: [`UsuarioId eq ${u.id}`]
                            }
                        });
                        return result;
                    }
                    else {
                        return api.list({
                            ...query,
                            ...{
                                $expand: ["Infractor", "Usuario", "ConvenioInfracciones"],
                                $select: ["Vencimiento_Cuota1", "Id", "CreatedAt", "Infractor", "Usuario", "ConvenioInfracciones", "EstadoPago"]
                            }
                        });
                    }
                }}
                itemActions={[
                    {
                        label: "Ver .pdf",
                        action: (item, sItems) => showPdf(item.Id!),
                        key: 'download'
                    },
                    {
                        label: "Ver infracciones",
                        action: (item, sItems) => setSelectedConvenio(item.Id),
                        key: 'infracciones'
                    },
                    {
                        label: "Ver estado cuotas",
                        action: (item, sItems) => verEstadoCuotas(item.Id),
                        key: 'estadoCuotas'
                    },
                    {
                        label: "Regenerar cuotas vencidas",
                        action: (item, sItems) => regenerarCuotasVencidas(item.Id),
                        key: 'cuotasVencidas'
                    }
                ]}
                delete={api.delete}
                deleteMultipleAction
                defaultSortOrder={"Id desc"}
                selectionType='checkbox'
                title={"Convenios de pago"}
                generateFilters={generateFilters}
                deleteItemAction
                deleteItemActionConfirmMessage={(item) => `¿Eliminar convenio ${item.Id}?`}
                defaultPageSize={25}

            >

                <Table.Column<ConvenioPago>
                    width={`5%`}
                    title="ID"
                    dataIndex={"Id"}
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                    sorter
                />

                <Table.Column<ConvenioPago>
                    width={`15%`}
                    title="Fecha de creación"
                    dataIndex={"CreatedAt"}
                    sortDirections={["ascend", "descend", "ascend"]}
                    sorter
                    render={(value, record) => moment(record.CreatedAt).format("DD/MM/YYYY HH:mm:ss")}
                />


                <Table.Column<ConvenioPago>
                    width={`30%`}
                    title="Infractor"
                    dataIndex={"Infractor"}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={cuitCuilFilterForm} >
                                <Form.Item name={"CuitCuil"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='CUIT/CUIL...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }}
                    render={(value, record) => `${record.Infractor.NombreCompletoTitular} (${record.Infractor.CuilTitular})`}
                />

                <Table.Column<ConvenioPago>
                    width={`10%`}
                    title="Cantidad de infracciones"
                    dataIndex={"ConvenioInfracciones"}
                    render={(value, record) => record.ConvenioInfracciones?.length}
                />

                <Table.Column<ConvenioPago>
                    width={`10%`}
                    title="Usuario"
                    dataIndex={"Usuario"}
                    render={(value, record) => `${record.Usuario.Nombre} ${record.Usuario.Apellido}`}
                />


                <Table.Column<ConvenioPago>
                    width={`20%`}
                    title="Estado vencimiento"
                    dataIndex={"Estado"}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={estadoVencimientoFilterForm} >
                                <Form.Item name={"EstadoVencimiento"} style={{ marginBottom: 10 }}>
                                    <Select placeholder="Estado de vencimiento...">
                                        <Select.Option key="1" value={1}>Activo</Select.Option>
                                        <Select.Option key="2" value={2}>Vencido</Select.Option>
                                    </Select>
                                </Form.Item>
                            </DataFilter>
                        );
                    }}
                    render={(value, record) => <strong
                        style={{ color: now < moment(record.Vencimiento_Cuota1) ? '#388e3c' : '#d32f2f' }}
                    >
                        <div>{now < moment(record.Vencimiento_Cuota1) ? 'ACTIVO' : 'VENCIDO'}</div>
                        <div>({moment(record.Vencimiento_Cuota1).format("DD-MM-YYYY")})</div>
                    </strong>}

                />

                <Table.Column<ConvenioPago>
                    width={`10%`}
                    title="Estado de pago"
                    dataIndex={"EstadoPago"}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={estadoPagoFilterForm} >
                                <Form.Item name={"EstadoPago"} style={{ marginBottom: 10 }}>
                                    <Select placeholder="Estado de pago...">
                                        <Select.Option key="1" value={'PAGADA'}>Pago</Select.Option>
                                        <Select.Option key="2" value={'IMPAGA'}>Impago</Select.Option>
                                        <Select.Option key="3" value={'PAGO_PARCIAL'}>Pago parcial</Select.Option>
                                    </Select>
                                </Form.Item>
                            </DataFilter>
                        );
                    }}
                    render={(value, record) => <strong
                        style={{ color: record.EstadoPago == 'PAGADA' ? '#388e3c' : '#d32f2f' }}
                    >{{
                        'IMPAGA': 'Impago',
                        'PAGADA': 'Pago',
                        'PAGO_PARCIAL': 'Pago parcial'
                    }[record.EstadoPago]}</strong>}

                />



            </DataTable>
        </MainLayout>
    );

};
